<template>
  <b-container>
      <h3 class="mt-1">Browse By {{ $store.state.globalTheme.AREA_ALIAS }}</h3>
    <hr style="margin-left: 1.5rem; margin-right: 1.5rem;">

  <b-row align-h="center" style="margin-left: 0.75rem; margin-right: 0.75rem;">
  <Area v-for="area in areas" :key="area.id" :name="area.name" :id="area.id" :image="area.image"/>
  </b-row>
  </b-container>
</template>

<script>
    import { getAPI } from '../store/axios-base'
    import Area from "./Area.vue";
    export default {
        name: "AllArea.vue",
        data:() => {
          return {
              areas: [],
          }
          },
        methods: {
            FetchData: function () {
                var headers = {}

                getAPI.get("/api/v1/sessions/?highlight=true", {headers: headers}).then(response => {
                    console.log(response);
                    this.areas = response.data.areas
                });

            },
        },
      mounted() {
            this.FetchData()
      },
        components:{
            Area
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/AllArea.vue